import React from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { LOAN_SECTION_KEYS } from "../loan.constants";
import { findSummaryText } from "../loanDetailEditUtil";

import { rows as sectionAmortizationRows } from "./section-amortization-rows";
import { rows as sectionGeneralInformationRows } from "./section-general-information-rows";

import { useFlags } from "launchdarkly-react-client-sdk";

const SHORTHAND_FIELD = "LoanEconomics";

const style = {
  stylename: "Work Sans /  16 Regular",
  fontFamily: "Work Sans",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "19px",
  letterSpacing: "0em",
  textAlign: "center",
  textColor: "#7d8084"
};

const LoanEconomics = props => {
  const { data, history, dealId, loanId, enableEditButton, modifySummaryText, eventHandlers, authentication, ...other } = props;
  const featureFlags = useFlags();
  const summaryText = findSummaryText(data, SHORTHAND_FIELD);
  const drawDataGeneralInformation = data => {
    if (data.details.amount ||
			data.details.currentPrincipalBalance ||
			data.details.currentPayment ||
			data.details.closingDate ||
			data.details.maturityDate ||
			data.details.extendedMaturityDate ||
			data.details.allInRate ||
			data.details.index ||
			data.details.rateTypeRef ||
			data.details.interestRate) {
        const generalInfoRows = sectionGeneralInformationRows(featureFlags);
      return <AccordionSection eventHandlers={eventHandlers} rows={generalInfoRows} data={data} />;
    }

    return <p style={style}>Data has not been entered for this section.</p>;
  };

  const drawDataAmortization = data => {
    if (data.amortizationDetails.amortization ||
			data.amortizationDetails.amortizationType ||
			data.amortizationDetails.interestCalculation ||
			data.amortizationDetails.ioPeriod ||
			data.amortizationDetails.amortMisc) {
      return <AccordionSection eventHandlers={eventHandlers} rows={sectionAmortizationRows} data={data} />;
    }

    return <p style={style}>Data has not been entered for this section.</p>;
  };
  
  const didSelectEditButton = (sectionKey) => {
    const { 
      gla697LoanEconomicsEditDestination: shouldNavigateToCashflows,
      us1304BrokerFrontendUrlEnvironmentVariable: brokerFrontendURL,
      bar2305RedirectToNewLoanEditPage: newEditLoanPageTenants = []
    } = featureFlags;

    const userCompanyId = authentication?.user?.contact?.company?.id;
    const shouldRedirectToNewEditPage = newEditLoanPageTenants.includes(userCompanyId);

    if (shouldRedirectToNewEditPage) {
      window.location.assign(`${brokerFrontendURL}/loans/${loanId}/edit`);
    } else if (shouldNavigateToCashflows) {
      window.location.assign(`${brokerFrontendURL}/borrower-deals/${dealId}/loan/${loanId}`);
    } else {
      history.push(`/loans/${loanId}/edit/${sectionKey}`);
    }
  };

  return (
    <ModuleAccordionGroup
      {...other}
      groups={[
        {
          title: "Loan Economics",
          key: LOAN_SECTION_KEYS.LOAN_ECONOMICS,
					 isTitleGroup: true,
					 isExpandable: false,
					 buttonLabel: null,
					 onClick: null,
					 hasSummaryText: true,
					 summaryText,
					 modifySummaryText: () => modifySummaryText(SHORTHAND_FIELD, summaryText)
        },
				 {
          title: "General Information",
          key: LOAN_SECTION_KEYS.GENERAL_INFORMATION,
					 isExpandable: true,
					 buttonLabel: "Edit Details",
          showEditButton: enableEditButton,
					 onClick: () => didSelectEditButton(LOAN_SECTION_KEYS.GENERAL_INFORMATION),
					 sections: [
            drawDataGeneralInformation(data)
          ],
					 references: data.references,
					 eventHandlers,
					 referencedFieldPath: "loans.generalinformation.header",
					 referenceStyles: { marginLeft: "20px" }
        },
				 {
          title: "Amortization",
          key: LOAN_SECTION_KEYS.AMORTIZATION,
					 isExpandable: true,
					 buttonLabel: "Edit Details",
          showEditButton: enableEditButton,
					 onClick: () => didSelectEditButton(LOAN_SECTION_KEYS.AMORTIZATION),
					 sections: [
            drawDataAmortization(data)
          ],
					 references: data.references,
					 eventHandlers,
					 referencedFieldPath: "loans.amortization.header",
					 referenceStyles: { marginLeft: "20px" }
        }
      ]}
    />
  );
};

export default LoanEconomics;
